/**
 * Convert key codes (used in HotkeyContext) to key names (expected by react-hotkeys-hook).
 * e.g., "KeyE" -> "E", "KeyC" -> "C", "Space" -> "SPACE", "Backspace" -> "BACKSPACE"
 */
export const keyCodeToKeyName = (keyCode: string): string => {
  if (keyCode.startsWith("Key")) {
    return keyCode.slice(3).toUpperCase();
  }
  if (keyCode.startsWith("Digit")) {
    return keyCode.slice(5).toUpperCase();
  }
  // Convert "Numpad1" to "1"
  if (keyCode.startsWith("Numpad")) {
    return keyCode.slice(6).toUpperCase();
  }
  if (keyCode.length === 1) {
    return keyCode.toUpperCase();
  }

  // Special keys
  const specialKeyMap: Record<string, string> = {
    Space: "space",
    Backspace: "backspace",
    ArrowLeft: "left",
    ArrowRight: "right",
    ArrowUp: "up",
    ArrowDown: "down",
    Enter: "enter",
    Escape: "escape",
    Tab: "tab",
    Comma: ",",
    Period: ".",
    Semicolon: ";",
    Slash: "/",
  };
  return specialKeyMap[keyCode] ?? keyCode.toUpperCase();
};

export const isSpecialKey = (keyCode: string): boolean => {
  return (
    keyCode.length !== 1 &&
    !keyCode.startsWith("Key") &&
    !keyCode.startsWith("Digit") &&
    !keyCode.startsWith("Numpad")
  );
};
